'use client';
import React, { useState } from 'react';
import { FileTextOutlined, DownloadOutlined, CalendarOutlined, UserOutlined, LeftOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';
import { BASE_FILE_URL, BASE_URL, BG_COLORS, COLORS } from '@/common/constants';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { useRouter } from 'next/navigation';
import { getWebsiteCodeHeader } from '@/common/pageConfig';
import { twMerge } from 'tailwind-merge';
import { formatDateVN } from '@/common/ultils';

export default function DocumentDetail({ documentDetail, postss, websiteCode, slugDetail }) {
  const router = useRouter();

  const [downloading, setDownloading] = useState(false); // Track downloading state for each item

  // // Hàm để lấy random page trong khoảng totalPages
  // const getRandomPage = () => {
  //   if (totalPages <= 1) return 1;
  //   return Math.floor(Math.random() * totalPages) + 1;
  // };

  // Hàm xử lý khi click vào document
  const handleDocumentClick = (item) => {
    router.push(`/van-ban/${item.slug}`);

    // // Gọi API với page ngẫu nhiên
    // const randomPage = getRandomPage();
    // setCurrentPage(randomPage);

    // // Scroll to top
    // if (typeof window !== 'undefined') {
    //   window.scrollTo({ top: 0, behavior: 'smooth' });
    // }
  };

  // Hàm download file qua API
  const handleDownloadFile = async (postsId, fileName) => {
    if (!postsId) return;

    try {
      setDownloading(true);

      const response = await fetch(`${BASE_URL}/postss/downloadFileDocuments/${postsId}`, {
        method: 'GET',
        headers: {
          websiteCode: getWebsiteCodeHeader(websiteCode),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Lấy blob từ response
      const blob = await response.blob();

      // Tạo URL tạm thời cho blob
      const url = window.URL.createObjectURL(blob);

      // Tạo thẻ a ẩn để trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || `document_${postsId}.pdf`; // Tên file mặc định
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch {
    } finally {
      setDownloading(false);
    }
  };

  const t = useTranslations('');
  function sanitizeHtmlContent(html) {
    if (!html || typeof document === 'undefined') return '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Xóa các thẻ img, video, audio
    const tagsToRemove = tempDiv.querySelectorAll('img, video, audio, .fig-picture');
    tagsToRemove.forEach((el) => el.remove());

    return tempDiv.innerHTML;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className={twMerge('container mx-auto bg-white', slugDetail ? 'px-2 md:px-4 py-2' : '')}>
        <div className="flex items-center">
          <button className={twMerge('mb-2 min-w-8 rounded mr-2 aspect-square', BG_COLORS.greenLight)} onClick={() => router.back()}>
            <LeftOutlined className="!text-white" />
          </button>
          <h1 className={twMerge('text-2xl font-bold mb-2', COLORS.primary)}>{documentDetail?.menu?.name ?? ''}</h1>
        </div>

        <div className="min-h-screen bg-gradient-to-br mb-3">
          <div className="mx-auto space-y-6">
            {/* Header Section */}
            <div className="bg-white shadow-lg border-0 rounded-2xl overflow-hidden">
              <div className="bg-gradient-to-r from-red-500 to-red-600 p-4">
                <div className="flex items-center gap-3 text-white">
                  <div className="p-2 bg-white/20 rounded-lg">
                    <FileTextOutlined className="text-2xl" />
                  </div>
                  <p className="text-xl font-bold text-white m-0">{t('pdfList.title')}</p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3 px-6 pt-6">
                <div className="w-full sm:w-44 flex-shrink-0 text-gray-600 font-medium text-sm sm:text-base">{t('pdfList.summary')}</div>

                <div
                  className="flex-1 py-1 rounded-md  text-sm overflow-x-auto"
                  dangerouslySetInnerHTML={{ __html: documentDetail?.content ?? '' }}
                />
              </div>

              <div className="px-6 pt-2 pb-6">
                {/* Document Info Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    {/* Ký hiệu */}
                    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
                      <div className="w-full sm:w-44 text-gray-600 font-medium text-sm sm:text-base">{t('pdfList.symbolNumber')}</div>
                      <div className="flex-1">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md  text-sm inline-block">{documentDetail?.title ?? ''}</span>
                      </div>
                    </div>

                    {/* Cơ quan ban hành */}
                    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
                      <div className="w-full sm:w-44 text-gray-600 font-medium text-sm sm:text-base">{t('pdfList.issuingAgency')}</div>
                      <div className="flex-1">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md  text-sm inline-block">
                          {documentDetail?.coQuanBanHanh?.name ?? ''}
                        </span>
                      </div>
                    </div>

                    {/* Loại văn bản */}
                    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
                      <div className="w-full sm:w-44 text-gray-600 font-medium text-sm sm:text-base">{t('pdfList.textType')}</div>
                      <div className="flex-1">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md text-sm inline-block">
                          {documentDetail?.loaiVanBan?.name ?? ''}
                        </span>
                      </div>
                    </div>

                    {/* Hiệu lực */}
                    {documentDetail?.endExpirationDate ? (
                      <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
                        <div className="w-full sm:w-44 text-gray-600 font-medium text-sm sm:text-base">{t('pdfList.effect')}</div>
                        <div className="flex-1">
                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md text-sm inline-block">
                            {documentDetail?.endExpirationDate ?? ''}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>

                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <CalendarOutlined className="text-gray-400 mt-1" />
                      <div className="flex items-center gap-1 text-sm">
                        <span className="text-gray-600 sm:w-44 sm:text-base">{t('pdfList.issuedDate')}:</span>
                        <div className="flex-1">
                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md text-sm inline-block">
                            {documentDetail?.issuanceDate ? formatDateVN(documentDetail.issuanceDate) : ''}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <CalendarOutlined className="text-gray-400 mt-1" />
                      <div className="flex items-center gap-1 text-sm">
                        <div className="text-sm text-gray-600 sm:w-44 sm:text-base">{t('pdfList.effectiveDate')}:</div>
                        <div className="font-medium">
                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md text-sm inline-block">
                            {documentDetail?.expirationDate ? formatDateVN(documentDetail.expirationDate) : ''}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <UserOutlined className="text-gray-400 mt-1" />
                      <div className="flex items-center gap-1 text-sm">
                        <div className="text-sm text-gray-600 sm:w-44 sm:text-base">{t('pdfList.signatory')}:</div>
                        <div className="font-medium">
                          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-md text-sm inline-block">
                            {documentDetail?.approvedBy ?? ''}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Status and Download */}
                <div className="mt-6 pt-6 border-t border-gray-100">
                  <div className="flex items-center justify-between">
                    {documentDetail?.fileDocuments?.length > 1 ? (
                      <button
                        onClick={() => {
                          handleDownloadFile(documentDetail?.id, documentDetail?.title);
                        }}
                        disabled={downloading}
                        className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 
                to-blue-700 text-white px-4 py-2 rounded-lg shadow-md hover:shadow-lg transition-all border-0 cursor-pointer">
                        <DownloadOutlined className="mr-2" />
                        {t('pdfList.download')}
                      </button>
                    ) : (
                      <button
                        className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 
                to-blue-700 text-white px-4 py-2 rounded-lg shadow-md hover:shadow-lg transition-all border-0 cursor-pointer">
                        <a
                          download
                          href={!isEmpty(documentDetail?.fileDocuments?.[0]) ? `${BASE_FILE_URL}/${documentDetail?.fileDocuments?.[0]}` : undefined}>
                          <DownloadOutlined className="mr-2" />
                          {t('pdfList.download')}
                        </a>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Related Documents */}
            <div className="bg-white shadow-lg border-0 rounded-2xl overflow-hidden">
              <div className="bg-gradient-to-r from-orange-600 to-red-600 p-4">
                <h3 className="text-white text-xl font-semibold m-0 flex items-center gap-2">
                  <FileTextOutlined />
                  {t('pdfList.titleOther')}
                </h3>
              </div>

              <div className="p-6 space-y-4">
                {get(postss, 'results', []).length > 0 ? (
                  postss.results.map((item, index) => (
                    <div key={item.id || index} className="group" onClick={() => handleDocumentClick(item)}>
                      <div
                        className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 
                  hover:bg-blue-50 transition-all duration-200 cursor-pointer hover:shadow-md">
                        <div className="w-2 h-2 bg-red-500 rounded-full mt-3 group-hover:bg-blue-500 transition-colors"></div>
                        <div className="flex-1">
                          <div className="font-medium text-gray-800 group-hover:text-blue-700 transition-colors leading-relaxed">{item.title}</div>
                          {item.content && (
                            <div
                              className="text-md content-articles ck ck-content ck-editor__editable 
                          ck-rounded-corners ck-editor__editable_inline ck-blurred line-clamp-3 !overflow-y-hidden"
                              dangerouslySetInnerHTML={{ __html: sanitizeHtmlContent(item.content) }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="font-medium text-gray-800 group-hover:text-blue-700 transition-colors leading-relaxed">{t('home.checkTable')}</div>
                )}
              </div>
            </div>

            {/* <div className="text-sm text-gray-500 text-center">
          Current Page: {currentPage} / Total Pages: {totalPages}
        </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
